<div class="video-element" (click)="open(data)">
  <div class="video-element__thumbnail">
    <app-picture [data]="createThumbnailData(getThumbnail(data))"></app-picture>
  </div>
</div>

<app-modal-video *ngIf="isShow" [isShow]="isShow" (close)="close()" [data]="showingItem"></app-modal-video>
